import React from 'react';
import { useTranslation } from 'react-i18next';
import { SignIn } from '@clerk/clerk-react';
import { Grid, Header } from 'semantic-ui-react';

import styles from './ClerkLogin.module.scss';

/**
 * ClerkLogin - Professional login component using Clerk
 * Uses Clerk's intelligent routing between login and signup
 */
const ClerkLogin = React.memo(() => {
  const [t] = useTranslation();

  return (
    <Grid verticalAlign="middle" className={styles.fullHeightPaddingFix}>
      <Grid.Column widescreen={4} largeScreen={5} computer={6} tablet={16} mobile={16}>
        <Grid verticalAlign="middle" className={styles.fullHeightPaddingFix}>
          <Grid.Column>
            <div className={styles.loginWrapper}>
              <div className={styles.logoContainer}>
                <img
                  src="/shaka white.svg"
                  alt="Shakkii Logo"
                  className={styles.logo}
                />
              </div>

              <Header
                as="h1"
                textAlign="center"
                content={t('common.logInToGo360')}
                className={styles.formTitle}
              />

              <p className={styles.subtitle}>
                Let's get things rolling.
              </p>

              <div className={styles.clerkContainer}>
                <SignIn
                  appearance={{
                    elements: {
                      formButtonPrimary: {
                        fontSize: '16px',
                        fontWeight: '600',
                        backgroundColor: '#4F81E7',
                        borderRadius: '8px',
                        border: 'none',
                        padding: '12px 24px',
                        textTransform: 'none',
                        '&:hover': {
                          backgroundColor: '#3D6FD9',
                        },
                      },
                      card: {
                        boxShadow: 'none',
                        border: 'none',
                        backgroundColor: 'transparent',
                      },
                      headerTitle: {
                        display: 'none', // Usamos nuestro título
                      },
                      formFieldInput: {
                        borderRadius: '8px',
                        border: '1px solid #e1e5e9',
                        padding: '12px 16px',
                        fontSize: '16px',
                        '&:focus': {
                          borderColor: '#4F81E7',
                          boxShadow: '0 0 0 3px rgba(79, 129, 231, 0.1)',
                        },
                      },
                      footerActionLink: {
                        color: '#4F81E7',
                        fontWeight: '500',
                        textDecoration: 'none',
                        '&:hover': {
                          textDecoration: 'underline',
                        },
                      },
                    },
                    layout: {
                      socialButtonsPlacement: 'top',
                    },
                  }}
                  redirectUrl="/"
                  afterSignInUrl="/"
                />
              </div>
            </div>
          </Grid.Column>
        </Grid>
      </Grid.Column>
    </Grid>
  );
});

export default ClerkLogin;
